import { Tabs, Tab, Typography } from '@mui/material';

import React, { useState, useEffect } from 'react';

import { makeStyles } from "@mui/styles";
import { horizontalTabStyles } from '../../sharedStyles';

import Litigation from './Litigation';

import FloatingMessage from '../../../../common/FloatingMessage';

import Retention from './Retention';

import DataDictionary from './DataDictionary';

import Users from './Users';

import { useNavigate } from "react-router-dom";
// Variable holds the Available tabs in the setting page
const SettingTabs = ["", "litigation", "retention", "users"];

const useStyles = makeStyles(() => ({

    erroralert: {
        float: 'right',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)'
    },
    catalogTab: {
        height: '100%',
        ...horizontalTabStyles.tabWrapper,
        '& .header': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold'
        },
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    },
    tabBody: {
        ...horizontalTabStyles.tabBody,
    }
}));

const Settings = ({ active }) => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState(0);
    const [error, setError] = useState('');
    const [messageType, setMessageType] = useState('error'); // 'error' or 'success'
    const navigate = useNavigate();
    useEffect(() => {
        if (error !== "") {
            // Removing the error messge after 999999 sec
            setTimeout(() => {
                setError("")
            }, 4000);
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[error])
    useEffect(() => {
        // Activating the Tab based on the tab param in the route url
        let activeTabIndex = SettingTabs.indexOf(active);
        // activating the first tab when the tab name does not match the list
        if (activeTabIndex < 0) {
            activeTabIndex = 0;
        }
        setActiveTab(activeTabIndex);
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[active])

    const handleTabChange = (_event, newValue) => {
        setActiveTab(newValue);
        // redirecting to the selected tab url so that refresh will retain in same page
        navigate(`/admin/systemsettings/${SettingTabs[newValue]}`)
    }
    return (<div className={classes.catalogTab}>
        <FloatingMessage open={error !== ""} message={error} severity={messageType} onClose={() => setError("")} />
        <Typography variant="h6" className='header'>
            SYSTEM SETTINGS
        </Typography>
        <Tabs
            variant="scrollable"
            aria-label="tabs"
            value={activeTab}
            onChange={handleTabChange}
            sx={{ borderColor: 'divider', width: '100%' }}
        >
            <Tab label="Data Dictionary" />
            <Tab label="Litigation" />
            <Tab label="Retention" />
            <Tab label="Users" />
        </Tabs>
        <div className={classes.tabBody}>
        {activeTab === 0 && (
            <DataDictionary toggleError={(msg, type = 'error') => {
                setError(msg);
                setMessageType(type);
            }} />
        )}
        {activeTab === 1 && (
            <Litigation toggleError={(msg, type = 'error') => {
                setError(msg);
                setMessageType(type);
            }} />
        )}
        {activeTab === 2 && (
            <Retention toggleError={(msg, type = 'error') => {
                setError(msg);
                setMessageType(type);
            }} />
        )}
        {activeTab === 3 && (
            <Users toggleError={(msg, type = 'error') => {
                setError(msg);
                setMessageType(type);
            }} />
        )}
        </div>

    </div>)
}
export default Settings;